// extracted by mini-css-extract-plugin
export var container = "contentTemplate-module--container--7xDz+";